import { render, staticRenderFns } from "./PayrollMainPage.vue?vue&type=template&id=00c11d74&scoped=true"
import script from "./PayrollMainPage.vue?vue&type=script&lang=js"
export * from "./PayrollMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c11d74",
  null
  
)

export default component.exports